import { grey } from '@mui/material/colors';

export default {
  styleOverrides: {  
    colorDefault: {
      backgroundColor: grey['100']
    },
  }
};
